module.exports = __webpack_public_path__ + "assets/img/menu-sessions.6bd6623d.svg";